import React from 'react';

const AWS_Innovation = () => {
  return (
    <div>
      <h1>AWS_Innovation</h1>
      <p>This is the AWS_Innovation component.</p>
    </div>
  );
};

export default AWS_Innovation;
